import { render, staticRenderFns } from "./BacklinksContractPopup.vue?vue&type=template&id=5e2d10c0&scoped=true"
import script from "./BacklinksContractPopup.vue?vue&type=script&lang=js"
export * from "./BacklinksContractPopup.vue?vue&type=script&lang=js"
import style0 from "./BacklinksContractPopup.vue?vue&type=style&index=0&id=5e2d10c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d10c0",
  null
  
)

export default component.exports